type DateInput = string | Date | null | undefined;

const toDate = (value: DateInput): Date | null => {
  if (!value) return null;
  return new Date(value);
};

export const normalizeDateOnly = (date: Date): Date => {
  const normalized = new Date(date);
  normalized.setHours(0, 0, 0, 0);
  return normalized;
};

export const isDatePassed = (dateValue?: DateInput): boolean => {
  const date = toDate(dateValue);
  if (!date) return false;

  const now = new Date();
  return date < now;
};

export const isDatePassedDateOnly = (dateValue?: DateInput): boolean => {
  const date = toDate(dateValue);
  if (!date) return false;

  return normalizeDateOnly(date) < normalizeDateOnly(new Date());
};
